// extracted by mini-css-extract-plugin
export default {"IdealFor":"idealfor_IdealFor__73FmB","list":"idealfor_list__KqmFG","second":"idealfor_second__SIULu","textContainer":"idealfor_textContainer__P2zMQ"};